import { useState, useEffect } from "react";
import styles from "./Banner.module.scss";
import logo from "../../../assets/svg/logo-banner.svg";
import { useUser } from "../../../providers/user.provider";
import { useWindowDimensions } from "../../../services/widthCheck.service";
import CloseIcon from "@mui/icons-material/Close";

interface Style {
  margin?: number;
  plans?: boolean;
  mytol?: boolean;
}

const Banner = (props: Style) => {
  const [close, setClose] = useState<boolean>(false);
  const { width } = useWindowDimensions();

  const { banner, setBanner, payment, user } = useUser();

  const handleClickClose = () => {
    setClose(false);
    setBanner(false);
  };

  const handleClickClaimOffer = () => {
    payment.forEach((item: any) => {
      if (item.description.description === "Premium Year") {
        window.open(
          item.external_url + `?prefilled_email=${user.email}`,
          "_blank"
        );
      }
    });
  };

  useEffect(() => {
    // Wait until user data is loaded
    if (!user || !user.id) {
      setClose(false);
      return;
    }

    const accessedAt = new Date(user?.accessed_at || "");
    const currentDate = new Date();

    // Hide banner if:
    // 1. User is admin or manager
    const isAdmin = (user?.role === "admin" || (user?.accessRoles && user?.accessRoles.some(role => [ 'superadmin', 'admin' ].includes(role.title))));
    const isManager = (user?.role === "manager" || (user?.accessRoles && user?.accessRoles.some(role => [ 'moderator' ].includes(role.title))));

    // 2. User has active top-tier subscription (Premium Year or Lifetime)
    const hasActiveTopSubscription =
      (user?.access === "premium" && user?.typeSubscription === "year" && accessedAt >= currentDate) ||
      (user?.typeSubscription === "lifetime" && accessedAt >= currentDate);

    // 3. Banner was closed by user
    if (isAdmin || isManager || hasActiveTopSubscription || !banner) {
      setClose(false);
    } else {
      setClose(true);
    }
  }, [banner, user]);

  return (
    <>
      {close ? (
        <div className={styles.banner}>
          <div className={styles.banner__inner}>
            {width >= 985 ? (
              <img
                width={114}
                height={45}
                src={logo}
                alt="the only link logo"                
              />
            ) : null}
            <p className={styles.banner__text}>
              <strong>Get 2 Months Free! </strong>Subscribe to the annual plan and enjoy 12 Months for the Price of 10. Get full access, save more, and maximize your Only Link experience!
            </p>
            <button onClick={handleClickClaimOffer}>Claim Offer</button>
          </div>

          <button
            style={{
              background: "transparent",
              border: "none",
              color: "#fff",
              marginLeft: "7px",
              minWidth: "14px",
              height: "24px",
            }}
            onClick={handleClickClose}
          >
            <CloseIcon />
          </button>
        </div>
      ) : null}
    </>
  );
};

export default Banner;
